import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { CartOption } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/LastCartsSelector/entities/CartOption';
import { LastItemSelectorWrapper } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/components/LastItemSelectorWrapper';
import { StoredCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/StoredCart';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface CartSelectorOptionProps {
  cart: StoredCart;
  removeCart: () => void;
}

export const CartSelectorOption = ({ cart, removeCart }: CartSelectorOptionProps) => {
  const { palette } = useCustomTheme();
  const { getTextIdTranslation } = useTranslation();

  const { totalCartValue, highestValueItemDescription, numberOfItemsInCart, dateOfCart, articleTypeIcon } =
    new CartOption(cart);

  return (
    <LastItemSelectorWrapper removeItem={removeCart}>
      <Box display={'flex'} gridGap={8} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <Icon size={18} color={palette.secondary.main}>
          {articleTypeIcon}
        </Icon>
        <Box gridGap={2} display={'flex'} flexDirection={'column'}>
          <Font variant="caption" color="textSecondary">
            {dateOfCart}
          </Font>
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gridGap={6}>
            <Font variant="body2" color="textPrimary">
              <strong>{formatMoney({ value: totalCartValue, currency: cart.cart.currency })}</strong>
            </Font>
            <Icon size={18}>arrow_right</Icon>
            <Font variant="body2" color="textPrimary">
              {numberOfItemsInCart === 1
                ? highestValueItemDescription ?? getTextIdTranslation('ARTICLE')
                : `${highestValueItemDescription} + ${numberOfItemsInCart - 1} ${
                    numberOfItemsInCart === 2 ? getTextIdTranslation('ITEM') : getTextIdTranslation('ITEMS')
                  }`}
            </Font>
          </Box>
        </Box>
      </Box>
    </LastItemSelectorWrapper>
  );
};
